module.exports = __webpack_public_path__ + "img/close_premium.029bcaf0.svg";